import { Stepper, Step, StepLabel, StepContent, Button, Typography } from "@material-ui/core";
import { Link as RouterLink } from 'react-router-dom';

export default function GetStarted({ activityCount,branchCount }) {
    const activeStep = branchCount === 0 ? 0 : 1;
    return (
        <>
            <Typography variant="h5"> Get started</Typography>
            <Stepper activeStep={activeStep} orientation="vertical">
                <Step >
                    <StepLabel>Add branches</StepLabel>
                    <StepContent>
                        <Typography gutterBottom>
                            Add atleast one Branch to get started
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: '8px' }}
                            component={RouterLink}
                            disableElevation
                            to="/branches">
                            Add Branch
                        </Button>
                    </StepContent>
                </Step>
                <Step >
                    <StepLabel>Add activites</StepLabel>
                    <StepContent>
                        <Typography gutterBottom>
                            Add atleast one activity to map to branches
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: '8px' }}
                            component={RouterLink}
                            disableElevation
                            to="/activities">
                            Add Activity
                        </Button>
                    </StepContent>
                </Step>
                
            </Stepper>
        </>
    )
}